  <template>
    <div class="bg-[#0B0B0F] text-white font-sans overflow-x-hidden">
      <main class="max-w-[70%] mx-auto px-4 pt-10 pb-16">
        <div class="grid grid-cols-1 lg:grid-cols-2 gap-x-10 gap-y-14 items-center">
          <div class="flex flex-col text-center lg:text-left">
            <h1 class="text-3xl sm:text-4xl md:text-5xl font-bold leading-snug">
              Aumente seu <span class="text-[#FF7A00]">faturamento</span> com a <span class="text-[#FF7A00]">Overx</span>
            </h1>
            <p class="mt-4 text-base text-gray-300 max-w-lg mx-auto lg:mx-0">
              Dezenas de empresas já aumentaram suas vendas em até 247% com nossas tecnologias. Descubra como podemos
              transformar seu negócio em meses.
            </p>

            <div class="mt-8 max-w-lg">
              <div class="flex gap-6 items-stretch">

                <div class="shrink-0">
                  <img
                    src="../../../public/images/ifood.png"
                    alt="iFood"
                    class="h-[8rem] sm:h-[11rem] md:h-[14rem] w-auto"
                  />
                </div>
                <div class="flex flex-col h-[8rem] sm:h-[11rem] md:h-[14rem] overflow-hidden">
                  <p class="text-xs sm:text-sm md:text-base text-gray-300 leading-snug sm:leading-normal md:leading-relaxed text-justify">
                    A Overx faz parte do programa de
                    <strong class="text-white">Super Integradoras do iFood</strong>,
                    garantindo integração homologada, segura e preparada para escalar
                    as vendas do seu negócio.
                  </p>
                </div>

              </div>
            </div>
          </div>

          <div class="w-full max-w-sm mx-auto">
            <div class="bg-white rounded-xl p-6 text-black shadow-2xl">
              <h2 class="text-lg font-bold text-center">Diagnóstico Digital Gratuito</h2>
              <p class="text-center text-sm text-gray-600 mt-1.5">
                Descubra como aumentar suas vendas em até 247% com as soluções personalizadas da Overx.
              </p>
              <form class="mt-5 space-y-3.5" @submit.prevent="abrirCalculadora">
                <input v-model="form.nome" type="text" placeholder="Seu nome"
                  class="w-full bg-gray-100 border border-gray-300 rounded-md px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-orange-500">
                <input v-model="form.email" type="email" placeholder="Seu melhor e-mail"
                  class="w-full bg-gray-100 border border-gray-300 rounded-md px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-orange-500">
                <input v-model="form.whatsapp" type="tel" placeholder="Seu whatsapp"
                  class="w-full bg-gray-100 border border-gray-300 rounded-md px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-orange-500">
                <select v-model="form.desafio"
                  class="w-full bg-gray-100 border border-gray-300 rounded-md px-4 py-2.5 text-sm text-gray-500 focus:outline-none focus:ring-2 focus:ring-orange-500">
                  <option disabled value="">Qual seu maior desafio atual?</option>
                  <option>Vendas</option>
                  <option>Gestão</option>
                  <option>Marketing</option>
                </select>
                <button type="submit"
                  class="w-full bg-[#FF7A00] text-white font-semibold py-3 rounded-lg text-sm hover:bg-orange-600 transition-colors">
                  QUERO MEU DIAGNÓSTICO GRÁTIS
                </button>
              </form>
              <p class="text-center text-xs text-gray-500 mt-3">
                Seus dados estão 100% seguros. Não compartilhamos suas informações.
              </p>
              <div class="mt-4 border-t pt-3">
                <p class="font-bold text-xs">Vagas limitadas para este mês:</p>
                <div class="w-full bg-gray-200 rounded-full h-2 mt-2">
                  <div class="bg-green-500 h-2 rounded-full" style="width: 23.33%"></div>
                </div>
                <p class="text-[10px] text-gray-600 mt-1">Apenas 7 vagas disponíveis de 30</p>
              </div>
            </div>
          </div>
        </div>
      </main>

      <CalculatorPopup 
        :show="showCalculator" 
        :formData="form" 
        @close="showCalculator = false" 
      />
    </div>
  </template>

  <script>
  import CalculatorPopup from "@/components/Calculator/CalculatorPopup.vue";

  export default {
    name: "OverxExactPage",
    components: { CalculatorPopup },
    data() {
      return {
        days: "02",
        hours: "11",
        minutes: "45",
        seconds: "19",
        intervalId: null,
        totalSeconds: 0,
        showCalculator: false,
        form: {
          nome: "",
          email: "",
          whatsapp: "",
          desafio: ""
        }
      };
    },
    methods: {
      abrirCalculadora() {
        // verifica se todos os campos estão preenchidos
        if (!this.form.nome || !this.form.email || !this.form.whatsapp || !this.form.desafio) {
          alert("Preencha todos os campos antes de abrir o diagnóstico!");
          return;
        }
        this.showCalculator = true;
      },
    },
  };
  </script>

  <style scoped>
  .font-sans {
    font-family: 'Inter', system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans', sans-serif;
  }
  </style>
